import loader from '../../assets/loader.gif'

const Loader = ({ sx, className }: { sx?: object; className?: string }) => {
  return (
    <div
      style={sx}
      className={className ? `loading ${className}` : 'loading'}
    >
      <img
        alt="loading..."
        src={loader}
      />
    </div>
  )
}

export default Loader
